export default __webpack_public_path__ + "static/media/BUSD-BNB.7399a376.png";